module.exports = __webpack_public_path__ + "static/media/01C.ba02d7ca.png";